import styled from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

import { NextDialog } from '../../../../../dialogs/NextDialog.client'

export const SizeChartButton = styled.button`
  ${TypeStyle.css.headlineMicro};
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  margin-inline-start: auto;
  text-decoration: underline;
  &:hover {
    color: ${o => o.theme.color.text.primary.on.background};
  }
`

export const DialogDrawer = styled(NextDialog)`
  ${fromMd} {
    max-width: 600px;
    width: 100%;
  }
`

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  contain: paint;
`
